export class GameHeaderStorage {
    public static header: PIXI.Container;
    public static score: PIXI.Text;
    public static mask: PIXI.Graphics;
    public static scoreMask: PIXI.Text;
    public static persent: PIXI.Text;
    public static originHeaderY: number;
    public static container: PIXI.Container;
    public static maskY: number = 150;
}